import React, { useState, useEffect } from 'react'
import { API_URL, formatDate, storedData, secret_key, mapMessage } from '../Constants';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import CryptoJS from "crypto-js";
import loading1 from "../../assets/loading.gif"

function Filterrecentsms() {
  const [searchTerm, setSearchTerm] = useState('');
  const [rsmses, setRsms] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true); 

  let navigate = useNavigate();

  if (storedData) {
    var bytes = CryptoJS.AES.decrypt(storedData, secret_key);
    var logeduserData = JSON.parse(bytes?.toString(CryptoJS.enc.Utf8));
  }

  const encryptedToken = localStorage.getItem('token');
  let decryptedToken = '';

  if (encryptedToken) {
    try {
      const decryptedBytes = CryptoJS.AES.decrypt(encryptedToken, secret_key);
      decryptedToken = decryptedBytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.log('Error.');
    }
  }

  const token = `Bearer ${decryptedToken}`;

  const fetchMessages = () => {
      let url;
      if(logeduserData.role_id == 4){
        url = `${API_URL}/get_all_last_seven_days_messages?page=${page}&limit=${50}`
      } else{
        url = `${API_URL}/get_last_seven_days_messages_byid/${logeduserData?.company_id}?page=${page}&limit=${50}`
      }

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: url,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token
        },
      };
      axios
        .request(config)
        .then(function (response) {
            if (response.data.length === 0) {
                setHasMore(false);
              } else {
                setRsms([...rsmses, ...response.data]);
                setPage(page + 1);
              }
        })
        .catch(function (error) {
            // handle errors
            if (error?.response?.status === 401) {
              navigate(0);
            }
            setLoading(false);
        })
    };

    useEffect(()=>{
        fetchMessages();
    })

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        fetchMessages();
      };

    const filteredrsms = rsmses.filter((rsms) => {
    const { name, phone_no, message_body, created_at } = rsms;
    const lowerCaseSearchTerm = searchTerm.toLowerCase();
    return (
        name?.toLowerCase().includes(lowerCaseSearchTerm) ||
        phone_no?.toLowerCase().includes(lowerCaseSearchTerm) ||
        message_body?.toLowerCase().includes(lowerCaseSearchTerm) ||
        created_at?.toLowerCase().includes(lowerCaseSearchTerm)
    );
    });

    const loadMoreMessages = () => {
        fetchMessages();
    }

  return (
    <div style={{paddingLeft:'10px'}}>
      <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0">Recent Messages</h1>
                </div>{/* /.col */}
                <div className="col-sm-6">
                  <ol className="breadcrumb float-sm-right">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active">Recent</li>
                  </ol>
                </div>{/* /.col */}
              </div>{/* /.row */}
            </div>{/* /.container-fluid */}
        </div>

      <form className="form-inline justify-content-end searchBar">
        <div className="input-group input-group-sm">
          <input
            className="form-control form-control-navbar"
            type="search"
            placeholder="Search"
            aria-label="Search"
            value={searchTerm}
            onChange={handleSearch}
          />
        </div>
      </form>

        <InfiniteScroll

            dataLength={filteredrsms.length}
            next={loadMoreMessages}
            hasMore={hasMore}
            loader={filteredrsms.length > 0 ? null : 
            <div className="loadingsubcontainer">
            <img className="loadingsubimg" src={loading1} alt="" />
            </div>}
            endMessage={<p>No more messages to load.</p>}
        >
        <table id="example" className="table table-striped">
        <thead>
            <tr>
                {/* <th>S/No</th> */}
                <th>Sender Id</th>
                <th>Sent</th>
                <th>Created At</th>
                <th>Sent At</th>
                <th>Phone No</th>
                <th>Message</th>
                {logeduserData.role_id == 4 ? <th>Company</th>:<th></th> }
                <th>Response </th>
            </tr>
        </thead>
        <tbody>
            {filteredrsms.map((rsms, index) => (
                <tr key={index}>
                  {/* <td>{index+1}</td> */}
                  <td>{rsms.sender_id}</td>
                  <td>{rsms.status}</td>
                  <td style={{ maxWidth: '100px', wordWrap: 'break-word' }}>{formatDate(rsms.created_at)}</td>
                  <td style={{ maxWidth: '100px', wordWrap: 'break-word' }}>{formatDate(rsms.time_sent_to_server)}</td>
                  <td>{rsms.phone_no}</td>
                  <td style={{ maxWidth: '300px', wordWrap: 'break-word' }}>{mapMessage(rsms.message_body)}</td>
                  {logeduserData.role_id == 4 ? <td>{rsms.name}</td>:<td></td> }
                  <td style={{ maxWidth: '300px', wordWrap: 'break-word' }}>{rsms.server_response}</td>
                </tr>
              ))}
        </tbody>
        </table>
        </InfiniteScroll>
    </div>
  )
}

export default Filterrecentsms